<script setup lang="ts">
const props = withDefaults(defineProps<{
  interactive?: boolean
  presentationConnected?: boolean
  showAnswersByDefault?: boolean
}>(), {
  interactive: true,
  presentationConnected: false,
  showAnswersByDefault: false,
})
</script>

<template>
  <div class="relative flex h-screen w-screen overflow-hidden bg-slate-950 text-white">
    <!-- ── Left: Wheel ────────────────────────────────── -->
    <div class="relative flex flex-1 items-center justify-center overflow-hidden p-4">
      <ChallengeWheelSpinWheel :interactive="props.interactive"/>
      <!-- ── Modal overlay scoped to wheel column ────── -->
      <ChallengeWheelChallengeModal
        :interactive="props.interactive"
        :presentation-connected="props.presentationConnected"
        :show-answers-by-default="props.showAnswersByDefault"
      />
    </div>

    <!-- ── Right: Sidebar ──────────────────────────────
         Timer pinned at top (shrink-0), teams claim the rest. The
         scoreboard's team boxes are themselves flex-1, so they share
         the available height equally and scale their text via
         container queries — no scrolling, no collision, fits any
         landscape viewport. The sidebar itself uses overflow-hidden
         as a belt-and-suspenders guard so a stray pixel of intrinsic
         text height never bleeds out and triggers a page scrollbar. -->
    <div class="flex min-w-32 w-[22vw] shrink-0 flex-col gap-4 p-4 h-full overflow-hidden">
      <div class="shrink-0">
        <ChallengeWheelCountdownTimer :interactive="props.interactive"/>
      </div>
      <div class="flex-1 min-h-0">
        <ChallengeWheelTeamScoreboard :interactive="props.interactive"/>
      </div>
    </div>
  </div>
</template>
